<div class="custom-notification">
  <ng-container *ngIf="assigneeName">
    <span class="assignee-name bold">
      {{ assigneeName }}
    </span>
    <span
      *ngIf="!notifyAssignee"
      class="bold"
      [ngClass]="{ underline: showCreateMessage }"
      (click)="showCreateMessage && openDialog()">
      won't be notified
    </span>

    <span *ngIf="notifyAssignee">
      will be notified
      <ng-container *ngIf="createOrNotifyOn === OnDueDateNotifyId; else customNotification">
        <span class="bold">on due date</span>
      </ng-container>

      <ng-template #customNotification>
        <ng-container *ngIf="customNotifyOnMode !== DynamicTicketTypeNotifyAssigneeMode.OnTicketCreation">
          <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn === OnDueDateNotifyId">
            on due date
          </span>

          <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn">
            {{ customNotifyOn | daysToString : inspectionType }}
          </span>
        </ng-container>

        <ng-container *ngIf="customNotifyOnMode === DynamicTicketTypeNotifyAssigneeMode.OnTicketCreation">
          <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn === OnDueDateNotifyId">
            on ticket creation
          </span>

          <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn">
            {{ customNotifyOn | daysToString : 'ticket creation' }}
          </span>
        </ng-container>

        <ng-container *ngIf="(remindOn || remindOn === 0) && remindOn !== DontNotifyId">
          , then
          <span class="bold underline" (click)="openDialog()">
            {{ remindOn | daysToString }}
          </span>
        </ng-container>

        <ng-container *ngIf="thenRemindOn > 0 && thenRemindOn !== DontNotifyId && (until > 0 || until === null)">
          , repeat every
          <span class="bold underline" (click)="openDialog()">{{ thenRemindOn }}d</span>
          until
          <span class="bold underline" *ngIf="until === null" (click)="openDialog()">completed</span>
          <span class="bold underline" *ngIf="until" (click)="openDialog()">{{ until }} times</span>
        </ng-container>
      </ng-template>
    </span>
  </ng-container>

  <span *ngIf="showCreateMessage">
    <span *ngIf="assigneeName">;&nbsp;</span>
    Inspection will be created
    <ng-container *ngIf="createOrNotifyOn === OnDueDateNotifyId; else createInspection">
      <span class="bold">on due date</span>
    </ng-container>

    <ng-template #createInspection>
      <ng-container *ngIf="createOrNotifyOn !== CustomNotifyId">
        <span class="bold underline" (click)="openDialog()" *ngIf="createOrNotifyOn">
          {{ createOrNotifyOn | daysToString : inspectionType }}
        </span>
      </ng-container>

      <ng-container *ngIf="createOrNotifyOn === CustomNotifyId">
        <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn === OnDueDateNotifyId">
          on due date
        </span>

        <span class="bold underline" (click)="openDialog()" *ngIf="customNotifyOn">
          {{ customNotifyOn | daysToString : inspectionType }}
        </span>
      </ng-container>
    </ng-template>
  </span>
</div>
